import React, { Component } from 'react';
import { Row, Col, Form, Button } from 'react-bootstrap';
import { Formik, Field } from 'formik';
import moment from 'moment';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import Layout from './DashboardLayout';
import { teamService, activityService, clientsService } from '../services';
import Loading from '../components/Loader';
import { ActivityList } from '../components/activity';
import {
  TeamMembersDropdown,
  WorkSessionTypeDropdown,
} from '../components/common';
import { DATE_RANGE_OPTIONS } from '../constants';
import { endTour, startTour } from '../actions';
import { setTourStepIndex } from '../actions/freeTrialTour';
import { setOnboardingProgressForTrackedWorkSession } from '../actions/user';

let params = new URLSearchParams(window.location.search);
class MemberActivity extends Component {
  state = {
    isLoading: true,
    siteId: '',
    clientId: '',
    teamMembersList: [],
    projectsList: [],
    startDate: params.get('fromDate') || moment().format('YYYY-MM-DD'),
    endDate: params.get('toDate') || moment().format('YYYY-MM-DD'),
    activityList: 0,
    teamMember: params.get('teamMember') || null,
    activityMetadata: {},
    isFetchingActivityData: false,
    isUpdatingTeamsList: false,
    selectedMember: null,
    clientsData: [],
  };

  memberActivityFormRef = React.createRef();

  pageHeading = {
    preTitle: 'Activity',
    title: 'Member Activity',
  };

  componentDidMount() {
    const { startInitTour, endInitTour } = this.props;
    if (localStorage.getItem('TourAutoStart')) {
      endInitTour();
      setTimeout(() => {
        startInitTour();
      }, 2000);
    }
    params = new URLSearchParams(window.location.search);
    this.getClientData();
    this.getTeamsData();
    const teamMember = params.get('teamMember');
    const startDate = params.get('fromDate');
    const endDate = params.get('toDate');
    if (teamMember && startDate && endDate) {
      this.handleGenerateData({
        teamOwnerId: localStorage.getItem('teamOwnerId'),
        teamMember,
        fromDate: moment(startDate).format('YYYY-MM-DD'),
        toDate: moment(endDate).format('YYYY-MM-DD'),
      });
    } else {
      this.setState((state) => ({
        ...state,
        teamMember: null,
        startDate: moment().format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
      }));
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { siteId, clientId } = this.state;
    if (siteId !== prevState.siteId) {
      this.getClientData();
      this.getTeamsData();
      this.memberActivityFormRef.current.setFieldValue('clientId', 'all');
      this.memberActivityFormRef.current.setFieldValue('teamMember', '');
    }
    if (clientId !== prevState.clientId) {
      this.getTeamsData();
      this.memberActivityFormRef.current.setFieldValue('teamMember', '');
    }
  }

  handleDateSelect = (event, picker) => {
    this.setState((state) => ({
      ...state,
      startDate: moment(picker.startDate).format('YYYY-MM-DD'),
      endDate: moment(picker.endDate).format('YYYY-MM-DD'),
    }));
  };

  getClientData = () => {
    const { siteId } = this.state;
    this.setState((state) => ({
      ...state,
      isLoading: true,
    }));
    const clientParams = {
      teamOwnerId: localStorage.getItem('teamOwnerId'),
      status: 'active',
      siteId,
    };
    if (siteId === 'all' || siteId === '') {
      delete clientParams.siteId;
    }
    clientsService
      .get_clients(clientParams)
      .then((clientData) => {
        if (clientData.data) {
          this.setState((state) => ({
            ...state,
            isLoading: false,
            clientsData: [...clientData.data],
          }));
        }
      })
      .catch(() => {
        this.setState((state) => ({
          ...state,
          isLoading: false,
        }));
      });
  };

  getTeamsData = () => {
    const { siteId, clientId } = this.state;
    this.setState((state) => ({
      ...state,
      isUpdatingTeamsList: true,
      isLoading: true,
    }));

    const teamParams = {
      teamOwnerId: localStorage.getItem('teamOwnerId'),
      summaryList: true,
      siteId,
      clientId: [clientId],
    };
    if (siteId === 'all' || siteId === '') {
      delete teamParams.siteId;
    }
    if (clientId === 'all' || clientId === '') {
      delete teamParams.clientId;
    }
    teamService
      .get_team_members_data(teamParams)
      .then((response) => {
        const { members } = response.data;
        this.setState((state) => ({
          ...state,
          isLoading: false,
          teamMembersList: [...members],
          isUpdatingTeamsList: false,
        }));
      })
      .catch(() => {
        this.setState((state) => ({
          ...state,
          isUpdatingTeamsList: false,
        }));
      })
      .finally(() => {
        this.setState((state) => ({
          ...state,
          isLoading: false,
        }));
      });
  };

  setStepIndexForActivityTour = (index) => {
    const { setInitTourStepIndex, endInitTour, startInitTour } = this.props;
    endInitTour();
    setInitTourStepIndex({ stepIndex: index });
    startInitTour();
  };

  handleGenerateData = (formdata) => {
    const {
      trackTaskTimeType,
      setInitOnboardingProgressForTrackedWorkSession,
      // permissions,
    } = this.props;
    this.setState((state) => ({
      ...state,
      isFetchingActivityData: true,
    }));

    const { startDate, endDate } = this.state;
    formdata.fromDate = startDate.concat(' 00:00:00');
    formdata.toDate = endDate.concat(' 23:59:59');
    if (formdata.workSessionType === 'all') {
      delete formdata.workSessionType;
    }
    const searchParams = new URLSearchParams(window.location.search);
    const projectId = searchParams.get('project');
    if (projectId) {
      formdata.projectId = projectId;
    }
    const activityParams = { ...formdata };
    activityParams.clientId = [formdata.clientId];
    if (formdata.siteId === 'all' || formdata.siteId === '') {
      delete activityParams.siteId;
    }
    if (formdata.clientId === 'all' || formdata.clientId === '') {
      delete activityParams.clientId;
    }
    activityService
      .get_activity_data(activityParams)
      .then((response) => {
        if ('activityData' in response.data) {
          const { activityData, metadata } = response.data;
          this.setState((state) => ({
            ...state,
            isFetchingActivityData: false,
            activityList: activityData,
            activityMetadata: metadata,
            selectedMember: activityData[0].user,
          }));
          if (activityData && activityData.length > 0) {
            setInitOnboardingProgressForTrackedWorkSession();
          }
          if (
            trackTaskTimeType &&
            trackTaskTimeType === 'Yes, I need activity monitoring'
          ) {
            this.setStepIndexForActivityTour(3);
          }
        } else {
          if (
            trackTaskTimeType &&
            trackTaskTimeType === 'Yes, I need activity monitoring'
          ) {
            this.setStepIndexForActivityTour(2);
          }
          this.setState((state) => ({
            ...state,
            isFetchingActivityData: false,
            activityList: [],
            selectedMember: null,
          }));
        }
      })
      .catch(() => {
        this.setState((state) => ({
          ...state,
          isFetchingActivityData: false,
          selectedMember: null,
        }));
      });
  };

  render() {
    const {
      teamMembersList,
      startDate,
      endDate,
      isFetchingActivityData,
      isLoading,
      activityList,
      isUpdatingTeamsList,
      teamMember,
      selectedMember,
      clientsData,
    } = this.state;

    const {
      location: { state: fromState },
      features,
      hierarchy,
      permissions,
    } = this.props;
    // Team owner ID
    const teamOwnerId = localStorage.getItem('teamOwnerId');
    const bredCrumbLinks =
      fromState && fromState.bredCrumbs ? fromState.bredCrumbs : [];
    return (
      <Layout pageHeading={this.pageHeading} bredCrumbLinks={bredCrumbLinks}>
        {selectedMember && (
          <h1 className="mb-5">
            {selectedMember.firstName} {selectedMember.lastName}’s activity
          </h1>
        )}
        <Formik
          initialValues={{
            teamOwnerId,
            siteId: 'all',
            clientId: 'all',
            teamMember:
              teamMember || (teamMembersList && teamMembersList[0]?.userId),
            fromDate: startDate,
            toDate: endDate,
            excludeArchivedProjects: true,
            isTeamMemberRequired:
              permissions &&
              permissions?.includes('team_member_view') &&
              permissions.includes('others_report_view'),
          }}
          validationSchema={Yup.object({
            teamMember: Yup.string().when('isTeamMemberRequired', {
              is: true,
              then: Yup.string().required('Please select any team member'),
              otherwise: Yup.string().notRequired(),
            }),
          })}
          innerRef={this.memberActivityFormRef}
          onSubmit={(values) => {
            this.handleGenerateData(values);
          }}
        >
          {(formikprops) => (
            <Form onSubmit={formikprops.handleSubmit} className="mb-5">
              <Row>
                {hierarchy?.sites?.length > 0 && (
                  <Col md={3}>
                    <Form.Group controlId="siteId">
                      <Form.Label>Site</Form.Label>
                      <Field
                        className="form-select"
                        as="select"
                        name="siteId"
                        onChange={(e) => {
                          formikprops.handleChange(e);
                          this.setState((state) => ({
                            ...state,
                            siteId: e.target.value,
                          }));
                        }}
                      >
                        <option value="all">All</option>
                        {hierarchy.sites.map((site) => (
                          <option key={site._id} value={site._id}>
                            {site.siteName}
                          </option>
                        ))}
                      </Field>
                    </Form.Group>
                  </Col>
                )}
                {permissions &&
                  permissions.includes('client_manage') &&
                  clientsData?.length > 0 && (
                    <Col md={6} lg={3}>
                      <Form.Group controlId="siteId">
                        <Form.Label>Client</Form.Label>
                        <Field
                          className="form-select"
                          as="select"
                          name="clientId"
                          onChange={(e) => {
                            formikprops.handleChange(e);
                            this.setState((state) => ({
                              ...state,
                              clientId: e.target.value,
                            }));
                          }}
                        >
                          <option value="all">All</option>
                          {clientsData.map((client) => (
                            <option key={client._id} value={client._id}>
                              {client.name}
                            </option>
                          ))}
                        </Field>
                      </Form.Group>
                    </Col>
                  )}
                {permissions &&
                  permissions?.includes('team_member_view') &&
                  permissions.includes('others_report_view') && (
                    <Col md={3}>
                      <TeamMembersDropdown
                        teamMembersList={teamMembersList}
                        handleChange={formikprops.handleChange}
                        isUpdatingTeamsList={isUpdatingTeamsList}
                        fieldLabel="Team Member"
                        isValidate
                        isDependentFiled
                        isRequired
                      />
                    </Col>
                  )}
                <Col md={3}>
                  <Form.Group>
                    <Form.Label>Date range</Form.Label>
                    <DateRangePicker
                      onEvent={this.handleDateSelect}
                      initialSettings={{
                        startDate: moment(startDate).toDate(),
                        endDate: moment(endDate).toDate(),
                        locale: {
                          format: 'MMM D, YYYY',
                        },
                        ranges: DATE_RANGE_OPTIONS,
                        alwaysShowCalendars: true,
                      }}
                    >
                      <input
                        type="text"
                        className="form-control icon-calendar"
                      />
                    </DateRangePicker>
                  </Form.Group>
                </Col>
                {features && features.isMobileTracking && (
                  <Col md={6} lg={3}>
                    <WorkSessionTypeDropdown />
                  </Col>
                )}
                <Col xs={12}>
                  <Form.Group controlId="excludeArchivedProjects">
                    <Form.Check
                      name="excludeArchivedProjects"
                      type="checkbox"
                      label="Exclude archived projects"
                      checked={formikprops.values.excludeArchivedProjects}
                      className="pt-3"
                      onChange={() =>
                        formikprops.setFieldValue(
                          'excludeArchivedProjects',
                          !formikprops.values.excludeArchivedProjects
                        )
                      }
                    />
                  </Form.Group>
                  <Form.Group>
                    <div>
                      <Button
                        variant="primary"
                        type="Submit"
                        disabled={
                          isUpdatingTeamsList || teamMembersList.length === 0
                        }
                        className="tour-for-generate"
                      >
                        Generate
                      </Button>
                    </div>
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
        {activityList !== 0 && <ActivityList activityList={activityList} />}
        {/* Loader */}
        {(isLoading || isFetchingActivityData) && <Loading contentAreaOnly />}
      </Layout>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    freeTrialTourReducer,
    featuresReducer,
    hierarchy,
    permissionsReducer,
  } = state;
  return {
    trackTaskTimeType: freeTrialTourReducer.trackTaskTimeType,
    features: featuresReducer,
    hierarchy,
    permissions: permissionsReducer,
  };
};

const mapDispatchToProps = () => ({
  startInitTour: startTour,
  endInitTour: endTour,
  setInitTourStepIndex: setTourStepIndex,
  setInitOnboardingProgressForTrackedWorkSession:
    setOnboardingProgressForTrackedWorkSession,
});

MemberActivity.propTypes = {
  location: PropTypes.object,
  endInitTour: PropTypes.any,
  startInitTour: PropTypes.any,
  setInitTourStepIndex: PropTypes.any,
  trackTaskTimeType: PropTypes.any,
  setInitOnboardingProgressForTrackedWorkSession: PropTypes.any,
  features: PropTypes.object,
  hierarchy: PropTypes.object,
  permissions: PropTypes.array,
};
export default connect(mapStateToProps, mapDispatchToProps())(MemberActivity);
